import { lazy } from "react";

export const NewUserPage = lazy(() => import("./newUserPage"));
